var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0C14.25 0 0 14.375 0 32C0 49.75 14.25 64 32 64C49.625 64 64 49.75 64 32C64 14.375 49.625 0 32 0ZM32 60C26 60 20.5 58.25 16 55.125C16.5 48.875 21.625 44 28 44H36C42.25 44 47.375 48.875 47.875 55.125C43.375 58.25 37.875 60 32 60ZM51.375 52.125C49.625 45.25 43.375 40 36 40H28C20.5 40 14.25 45.25 12.5 52.125C7.25 47 4 39.875 4 32C4 16.625 16.5 4 32 4C47.375 4 60 16.625 60 32C60 39.875 56.625 47 51.375 52.125ZM32 16C26.375 16 22 20.5 22 26C22 31.625 26.375 36 32 36C37.5 36 42 31.625 42 26C42 20.5 37.5 16 32 16ZM32 32C28.625 32 26 29.375 26 26C26 22.75 28.625 20 32 20C35.25 20 38 22.75 38 26C38 29.375 35.25 32 32 32Z",
    fill: "url(#paint0_linear_1982_5452)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1982_5452",
    x1: 64,
    y1: 0,
    x2: -6.2439,
    y2: 7.80488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009DE0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.f5a9fd138fd3711e5d6b97cb25bf3ef3.svg";
export { ForwardRef as ReactComponent };